<template>
  <div>
    <v-simple-table>
      <thead>
        <tr>
          <th>
            <v-btn icon @click="fetchData"><v-icon>mdi-refresh</v-icon></v-btn>
          </th>
          <th v-for="day in days" :key="day" class="text-center">{{ day }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="halfDay in halfDays" :key="halfDay">
          <th class="text-right">{{ halfDay }}</th>
          <template v-for="day in days">
            <BlockItem
              v-if="forced"
              :key="'force' + day"
              :day="day"
              :time="halfDay"
              :wishId="wishId"
              :value="getSlot(day, halfDay)"
              @update="fetchData"
              :disabled="disabled"
            />
            <WishItem
              v-else
              :key="'wish' + day"
              :day="day"
              :time="halfDay"
              :wishId="wishId"
              :value="getSlot(day, halfDay)"
              @update="fetchData"
              :disabled="disabled"
            />
          </template>
        </tr>
      </tbody>

      <thead>
        <tr>
          <th></th>
          <th v-for="day in days" :key="day" class="text-center">{{ day }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="lesson in lessons" :key="lesson">
          <th class="text-right">{{ lesson }}</th>
          <template v-for="day in days">
            <BlockItem
              :key="'force' + day"
              v-if="forced"
              :day="day"
              :time="lesson"
              :wishId="wishId"
              :value="getSlot(day, lesson)"
              @update="fetchData"
              :disabled="disabled"
            />

            <WishItem
              :key="'wish' + day"
              v-else
              :day="day"
              :time="lesson"
              :wishId="wishId"
              :value="getSlot(day, lesson)"
              @update="fetchData"
              :disabled="disabled"
            />
          </template>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import BlockItem from "./BlockItem.vue";
import WishItem from "./WishItem.vue";

export default defineComponent({
  components: { BlockItem, WishItem },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    forced: {
      type: Boolean,
      required: false,
      default: false,
    },
    wishId: {
      type: Number,
      required: true,
    },
  },
  name: "TableBlocked",
  data() {
    return {
      loading: false,
      wishSlots: [],
      days: ["Mo", "Di", "Mi", "Do", "Fr"],
      halfDays: ["Vormittag", "Nachmittag"],
      lessons: [
        "07.50",
        "08.45",
        "09.40",
        "10.40",
        "11.35",
        "12.30",
        "13.25",
        "14.20",
        "15.20",
        "16.15",
        "17.10",
      ],
    };
  },
  computed: {},

  watch: {
    wishId() {
      this.fetchData();
    },
  },
  methods: {
    getSlot(day, time) {
      return (
        this.wishSlots.find((s) => s.day == day && s.time == time) || {
          id: 0,
          wishId: this.wishId,
          comment: null,
        }
      );
    },
    async fetchData() {
      this.loading = true;
      this.wishSlots = (
        await this.apiList({
          resource: "teacher/wishslot",
          query: "wish=" + this.wishId,
        })
      ).filter((el) => el.forced == this.forced);
      this.$emit("loaded", this.wishSlots.length > 0);
      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
